import { render } from "./VehicleDetails.vue?vue&type=template&id=369bb013"
import script from "./VehicleDetails.vue?vue&type=script&lang=js"
export * from "./VehicleDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__